/**
 *
 * Asynchronously loads the component for AgenziaKiron
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/AgenziaTecnocasa/Loadable.js